// deeplink-gate.ts
export class DeeplinkGate {
  private lockUntil = 0;              // anti-rafale (ms epoch)
  private recentlyClosedUntil = 0;    // fenêtre où on refuse les opens non-gestures
  private lastOpenAt = 0;
  private awaitingReturn = false;     // on vient d'ouvrir → on attend le retour

  constructor(private cooldownMs = 1500, private afterCloseMs = 800) {
    // Quand l’utilisateur revient de MetaMask, on “réarme” le gate.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.awaitingReturn = false;
        // petite fenêtre “après fermeture” où on bloque tout open non-gesture
        this.recentlyClosedUntil = Date.now() + this.afterCloseMs;
      }
    });
  }

  canOpenNow(): boolean {
    const t = Date.now();
    if (t < this.lockUntil) return false;
    if (this.awaitingReturn) return false;               // on a déjà un open en vol
    return true;
  }

  /**
   * Doit être appelé SYNCHRONE dans le handler du clic (gesture).
   * Retourne true s’il a effectivement déclenché l’ouverture.
   */
  openOnceFromGesture(url: string, log?: (s: string) => void): boolean {
    const t = Date.now();

    // si on sort d'une fermeture, seules les ouvertures “gesture” passent
    const inAfterCloseWindow = t < this.recentlyClosedUntil;

    if (!this.canOpenNow()) {
      log?.(`[deeplink] blocked (lock/await) t=${t} lockUntil=${this.lockUntil}`);
      return false;
    }

    // régler le lock AVANT d'ouvrir (anti double fire)
    this.lockUntil = t + this.cooldownMs;
    this.awaitingReturn = true;
    this.lastOpenAt = t;

    try {
      // IMPORTANT: ouverture synchronisée au geste (pas d'await avant)
      window.location.href = url; // ou location.assign(url)
      log?.(`[deeplink] open url=${url} t=${t} inAfterClose=${inAfterCloseWindow}`);
      return true;
    } catch (e) {
      this.awaitingReturn = false; // si ça jette, on réarme
      log?.(`[deeplink] open failed: ${(e as Error).message}`);
      return false;
    }
  }

  /** Pour les cas non-gesture, on ne laisse rien passer juste après une fermeture */
  openNonGesture(url: string, log?: (s: string) => void): boolean {
    const t = Date.now();
    if (t < this.recentlyClosedUntil || t < this.lockUntil || this.awaitingReturn) {
      log?.(`[deeplink] non-gesture blocked t=${t}`);
      return false;
    }
    this.lockUntil = t + this.cooldownMs;
    this.awaitingReturn = true;
    try {
      window.location.href = url;
      log?.(`[deeplink] non-gesture open url=${url}`);
      return true;
    } catch (e) {
      this.awaitingReturn = false;
      log?.(`[deeplink] non-gesture failed: ${(e as Error).message}`);
      return false;
    }
  }

  /** À appeler si tu détectes un abandon/cancel explicitement */
  cancelInFlight() {
    this.awaitingReturn = false;
    this.lockUntil = Date.now() + this.cooldownMs;
    this.recentlyClosedUntil = Date.now() + this.afterCloseMs;
  }
}
